<template>
  <div class="col-12 d-flex flex-column mb-3">
    <div style="flex: 1;margin-left: 45px;">
      <div class="row">
        <div class="col-12">
          <section-title :title="label" />
        </div>
      </div>
    </div>
    <div class="row mb-1">
      <div
        v-for="(item, index) in selected"
        :key="index"
        class="col-12"
      >
        <div class="form-row">
          <div
            :class="{'col-md-9': !disabled, 'col-md-8': disabled}"
            class="mb-2"
            style="height: 38px;">
            <div class="d-flex">
              <div style="width: 45px;"/>
              <div
                class="form-row"
                style="flex: 1;">
                <div class="col-4">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{ $t('series.serial') }}</span>
                    </div>
                    <input
                      :value="item.serCode"
                      :disabled="true"
                      class="form-control text-right"
                    >
                  </div>
                </div>
                <div class="col-4">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{ $t('apps.inventory.label.serialnumber') }}</span>
                    </div>
                    <input
                      :value="item.serialNumber"
                      :disabled="true"
                      class="form-control text-right"
                    >
                  </div>
                </div>
                <div class="col-4">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{ $t('apps.inventory.label.bin') }}</span>
                    </div>
                    <input
                      :value="item.binName"
                      :disabled="true"
                      class="form-control text-right"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-2">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ $t('message.quantity') }}</span>
              </div>
              <input
                :value="item.unit"
                :disabled="true"
                class="form-control text-right"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="flex: 1;margin-left: 45px;">
      <div class="row">
        <div class="col-12">
          <BaseButton
            v-if="!disabled"
            :disabled="loading"
            className="btn-sm"
            @click="onClickOpenModal"
          >
            {{ $t('apps.inventory.button.selectserialnumber') }}
            <i
              v-if="loading"
              class="fas fa-spinner spin"/>
          </BaseButton>
        </div>
      </div>
    </div>
    <BaseSelectSerialNumberModal
      :show="modal.show"
      :loading="modal.loading"
      :serials="serials"
      :selected="selected"
      :index="index"
      :skuId="skuId"
      @onClose="handleCloseModal"
      @onCancel="handleCancleModal"
      @onSubmit="handleSumitModal"
      @onSortChange="handleSortChange"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    index: [String, Number],
    skuId: String,
    selected: Array,
    disabled: Boolean,
    label: String,
    selectedWhId: String,
    selectedBinId: [Object, String],
  },

  data () {
    return {
      loading: false,
      modal: {
        show: false,
        loading: false,
        sort: {
          key: 'date_in',
          value: 'asc',
        },
      },
    }
  },

  computed: {
    ...mapState('serial', {
      serials: 'serialList',
    }),
  },

  methods: {
    ...mapActions('serial', {
      getSerialList: 'getSerialList',
    }),
    async fetchData () {
      await this.getSerialList({
        page: 1,
        limit: 100000,
        'filter[sku_id]': this.skuId,
        'filter[wh_id]': this.selectedWhId,
        'filter[bin_location_id]': this.selectedBinId,
        'filter[unit_balance_empty]': 'false',
        'sort[key]': this.modal.sort.key,
        'sort[value]': this.modal.sort.value,
      })
      this.showFinish(this.$Progress)
    },
    async onClickOpenModal () {
      this.loading = true
      await this.fetchData()
      this.loading = false
      this.modal.show = true
    },
    handleCloseModal () {
      this.modal.show = false
    },
    handleCancleModal () {
      this.modal.show = false
    },
    async handleSumitModal ({ serials }) {
      this.modal.show = false
      this.$emit('onSubmit', { index: this.index, serials })
    },
    async handleSortChange ({ key, value }) {
      this.modal.loading = true
      this.modal.sort.key = key
      this.modal.sort.value = value
      await this.fetchData()
      this.modal.loading = false
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseSelectSerialNumber.vue